<script setup lang="ts">
import { computed, onMounted, ref, watch } from 'vue'
import { getRandomHexColor, hexWithOpacity } from '@/utils/helper.ts'
import { object } from 'zod'
interface Props {
  data: any
}
const props = defineProps<Props>()

const chartData = ref();
const chartOptions = ref(undefined);

const labelSet = computed(() => {
  if(!props.data || props.data.length == 0) return []
  return props.data.map((item: any) => {
    return item.category
  })
})

const dataSet = computed(() => {
  if(!props.data || props.data.length == 0) return []
  return props.data.map((item: any) => {
    return item.value
  })
})

const colorSet = computed(() => {
  const obj: any = {
    backgroundColor: [],
    hoverColor: [],
  }
  if(!props.data || props.data.length == 0) return obj
  props.data.forEach(() => {
    const color = getRandomHexColor()
    obj.backgroundColor.push(color)
    obj.backgroundColor.push(hexWithOpacity(color, 0.7))
  })
  return obj
})


const setChartData = () => {
  return {
    labels: labelSet.value,
    datasets: [
      {
        data: dataSet.value,
        backgroundColor: colorSet.value.backgroundColor,
        hoverBackgroundColor: colorSet.value.hoverColor,
      }
    ]
  };
};

const setChartOptions = () => {
  const documentStyle = getComputedStyle(document.documentElement);
  const textColor = documentStyle.getPropertyValue('--p-text-color');

  return {
    plugins: {
      legend: {
        labels: {
          cutout: '60%',
          color: textColor
        }
      }
    }
  };
};

onMounted(() => {
  chartData.value = setChartData();
  chartOptions.value = setChartOptions();
});

watch(() => props.data, (newVal, oldVal) => {
  chartData.value = setChartData();
  chartOptions.value = setChartOptions();
})
</script>

<template>
  <div class="flex w-full items-center justify-center">
    <Chart type="doughnut" :data="chartData" :options="chartOptions" class="w-full md:w-[250px]" />
  </div>
</template>

<style scoped>

</style>
